export const AppConfig = {
  baseUrl: "https://safex.servepratham.com/api/"
}